import { CurrentUserService } from '@activia/cm-api';
import { ChartCoreModule, CountCardModule, PieModule, TimeseriesModule } from '@activia/dataviz';
import {
  ButtonModule,
  CheckboxModule,
  CoreModule,
  EmptyDataMessageModule,
  FileSizePipe,
  IconModule,
  LayoutModule,
  LoaderModule,
  ModalModule,
  ProgressbarModule,
  TreeviewModule,
  WidgetModule,
} from '@activia/ngx-components';
import { AuthModule } from '@amp/auth';
import { DurationPipe, UIModule } from '@amp/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DashboardWidgetsDrawerComponent } from './components/dashboard-widgets-drawer.component';
import { ContentOverviewComponent } from './content/content-overview.component';
import { ContentOverviewService } from './content/content-overview.service';
import { DashboardComponent } from './dashboard.component';
import { MonitoringSpeedService } from './monitoring-speed/monitoring-speed.service';
import { ServerOverviewComponent } from './server/server-overview.component';
import { ServerOverviewService } from './server/server-overview.service';
import { ServerProcessComponent } from './server/server-process.component';
import { DashboardEffects } from './store/dashboard.effects';
import { dashboardInitialState, dashboardReducer } from './store/dashboard.reducer';
import { TimeSeriesWidgetComponent } from './time-series-widget/time-series-widget.component';
import { MonitoringSpeedComponent } from './monitoring-speed/monitoring-speed.component';
import { ServerOverviewWidgetComponent } from './server/server-overview-widget/server-overview-widget.component';
import { ThresholdThemePipe } from './pipes/threshold-theme.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: DashboardComponent,
        pathMatch: 'full',
      },
    ]),
    StoreModule.forFeature('dashboard', dashboardReducer, { initialState: dashboardInitialState }),
    EffectsModule.forFeature([DashboardEffects]),
    LoaderModule,
    CoreModule,
    ButtonModule,
    IconModule,
    ModalModule,
    CheckboxModule,
    TreeviewModule,
    LayoutModule,
    ProgressbarModule,
    WidgetModule,
    AuthModule,
    UIModule,
    TranslocoModule,
    CountCardModule,
    TimeseriesModule,
    ChartCoreModule,
    PieModule,
    EmptyDataMessageModule,
  ],
  declarations: [
    DashboardComponent,
    ServerOverviewComponent,
    ServerProcessComponent,
    ContentOverviewComponent,
    TimeSeriesWidgetComponent,
    DashboardWidgetsDrawerComponent,
    MonitoringSpeedComponent,
    ServerOverviewWidgetComponent,
    ThresholdThemePipe,
  ],
  providers: [
    { provide: TRANSLOCO_SCOPE, useValue: 'dashboard-scope', multi: true },
    CurrentUserService,
    ServerOverviewService,
    ContentOverviewService,
    FileSizePipe,
    DurationPipe,
    MonitoringSpeedService,
  ],
  entryComponents: [DashboardWidgetsDrawerComponent],
})
export class DashboardModule {}
